/* eslint-disable no-console */
import {Col, Form, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React from 'react';

import {CommonErrors} from '../../../../constants/Common';
import {EfdbName} from '../../../../constants/efdbNameConstants';
import NumberInput from '../../../../shared/NumberInput';
import useJSONStore from '../../../../store/StaticJson/jsonStore';
import RegEx from '../../../../utils/FormUtils/RegEx';
import {
  ProductInfoKey,
  ProductInfoLabel
} from '../../Constants/Products/ProductInfoKeyLabel';
import {unitTypes} from '../../interface/unitChange';
import changeUnit from '../changeUnit';
import {filterSelectOptions} from '../commonFunctions';

const ProductInfoRaw: React.FC<{
  name?: any;
  key?: number;
  fields?: any;
  mainName?: string;
}> = ({name, mainName}) => {
  const tableCol = 12;
  const rawMaterials = useJSONStore
    .getState()
    .rawMaterials.filter((item) => item?.dbName === EfdbName.eeio);
  const {getFieldValue} = useFormInstance();

  const filterSelectOption = (value: any) => {
    return rawMaterials
      .filter((item) => {
        return !getFieldValue(mainName)?.some((tableItem: any) => {
          return value
            ? tableItem?.[ProductInfoKey.RAW_MATERIAL_ID] === item?.value &&
                value !== item.value
            : tableItem?.[ProductInfoKey.RAW_MATERIAL_ID] === item?.value;
        });
      })
      .filter((item: any) => item?.dbName === EfdbName.eeio);
  };

  return (
    <>
      <Col className="gutter-row" span={tableCol}>
        <Form.Item dependencies={[mainName]} noStyle>
          {() => (
            <Form.Item
              name={[name, ProductInfoKey.RAW_MATERIAL_ID]}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(
                    ProductInfoLabel.RAW_MATERIAL_ID
                  )
                }
              ]}
              label={ProductInfoLabel.RAW_MATERIAL_ID}
              labelCol={{span: 24}}
              validateFirst
              hasFeedback
            >
              <Select
                showSearch
                className="select"
                placeholder={`Choose ${ProductInfoLabel.RAW_MATERIAL_ID}`}
                filterOption={filterSelectOptions}
                options={filterSelectOption(
                  getFieldValue([
                    mainName,
                    name,
                    ProductInfoKey.RAW_MATERIAL_ID
                  ])
                )}
              />
            </Form.Item>
          )}
        </Form.Item>
      </Col>
      <Col className="gutter-row" span={tableCol}>
        <Form.Item
          dependencies={[
            mainName,
            [mainName, name, ProductInfoKey.RAW_MATERIAL_ID]
          ]}
          noStyle
        >
          {() => {
            const rawMaterialId = getFieldValue([
              mainName,
              name,
              ProductInfoKey.RAW_MATERIAL_ID
            ]);
            const selectedRaw = rawMaterials.find(
              (item) => item.value === rawMaterialId
            );

            return (
              <Form.Item
                name={[name, ProductInfoKey.WEIGHT]}
                rules={[
                  {
                    required: true,
                    message: CommonErrors.mandatory(ProductInfoLabel.WEIGHT)
                  },
                  {
                    pattern: RegEx.twoDigitDecimal,
                    message: CommonErrors.twoDigitPositive
                  }
                ]}
                label={ProductInfoLabel.WEIGHT}
                labelCol={{span: 24}}
                validateFirst
                hasFeedback
              >
                <NumberInput
                  placeholder={`Enter ${ProductInfoLabel.WEIGHT}`}
                  addonAfter={changeUnit(selectedRaw?.state ?? unitTypes.WEIGHT)}
                />
              </Form.Item>
            );
          }}
        </Form.Item>
      </Col>
    </>
  );
};

export default ProductInfoRaw;
